import * as tslib_1 from "tslib";
import { Model } from '@app/models/model';
import { config } from '@config/config';
var Location = /** @class */ (function (_super) {
    tslib_1.__extends(Location, _super);
    function Location() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Location.prototype, "fullAddress", {
        get: function () {
            if (this.address_2) {
                this.streetAddress = this.address + ', ' + this.address_2;
            }
            else {
                this.streetAddress = this.address;
            }
            return this.streetAddress + ", " + this.city + " " + this.state + " " + this.postal_code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "status", {
        get: function () {
            return config.locationStatus[this.installation];
        },
        enumerable: true,
        configurable: true
    });
    Location.prototype.calculateOverallStatus = function () {
        if (this.status === 'Active' && this.ws && !this.ws.connected) {
            this.overallStatus = 'Offline';
        }
        else if (this.status === 'Active' && !this.ws) {
            this.overallStatus = config.locationStatus['NOT_STARTED'];
        }
        else {
            this.overallStatus = this.status;
        }
    };
    return Location;
}(Model));
export { Location };
var LocationAppliances = /** @class */ (function (_super) {
    tslib_1.__extends(LocationAppliances, _super);
    function LocationAppliances() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LocationAppliances;
}(Model));
export { LocationAppliances };
